import React from "react";
import CourierAction from "./courier-action";

const RowActions = ({
  onEdit,
  onDelete,
  editTitle = "Edit",
  deleteTitle = "Delete",
  editDisabled,
  deleteDisabled,
  editDisabledTitle,
  deleteDisabledTitle
}) => (
  <span className="courier-row-actions">
    {onEdit != null && (
      <CourierAction
        title={editTitle}
        iconClass="icon-edit"
        onClick={onEdit}
        disabled={editDisabled}
        disabledTitle={editDisabledTitle}
      />
    )}
    {onDelete != null && (
      <CourierAction
        title={deleteTitle}
        iconClass="icon-cancel"
        onClick={onDelete}
        disabled={deleteDisabled}
        disabledTitle={deleteDisabledTitle}
      />
    )}
  </span>
);

export default RowActions;
